class LiftKitsSection extends HTMLElement {
  #cartBtns = [];
  #freebies = [];
  #controller = null;

  connectedCallback() {
    this.#cartBtns = Array.from(this.querySelectorAll('[data-kit-cart-btn]'));
    this.#freebies = Array.from(this.querySelectorAll('[data-freebie-card]'));
    if (!this.#cartBtns.length) return;
    this.#bindEvents();
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  #bindEvents() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    for (const btn of this.#cartBtns) {
      btn.addEventListener('click', () => this.#addToCart(btn), { signal });
    }
  }

  async #addToCart(btn) {
    const variantId = Number(btn.dataset.variantId);
    if (!variantId) return;

    const freebieItems = this.#freebies
      .filter((f) => f.dataset.variantId)
      .map((f) => ({ id: Number(f.dataset.variantId), quantity: 1 }));

    const items = [{ id: variantId, quantity: 1 }, ...freebieItems];

    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    btn.textContent = btn.dataset.loadingText ?? 'Adding...';

    console.log('Adding to cart:', items);

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });

      if (!res.ok) {
        const { description } = await res.json();
        throw new Error(description ?? 'Cart error');
      }

      // const discountCode = this.dataset.discountCode?.trim();
      // if (discountCode) {
      //   window.location.href = `/discount/${encodeURIComponent(discountCode)}?redirect=/cart`;
      //   return;
      // }

      if (window.Rebuy?.Cart?.fetchCart) {
        window.Rebuy.Cart.fetchCart();
      }

      btn.setAttribute('aria-busy', 'false');
      btn.disabled = false;
      btn.textContent = btn.dataset.addText ?? 'Add to Cart';
    } catch {
      btn.setAttribute('aria-busy', 'false');
      btn.disabled = false;
      btn.textContent = btn.dataset.errorText ?? 'Error — try again';
      setTimeout(() => {
        btn.textContent = btn.dataset.addText ?? 'Add to Cart';
      }, 3000);
    }
  }
}

customElements.define('lift-kits-section', LiftKitsSection);
